export default __webpack_public_path__ + "static/media/elephant_ANGRY.4814747b.png";